<template>
<div class="PatrolStatistics">
  <div class="mainContent" :style="styleObject">
    <div class="container">
      <div class="chartContainer" :style="styleObject">
        <div class="leftAsides common">
          <div class="query">
            <span>
              <el-date-picker v-model="date" type="date" placeholder="选择日期时间">
              </el-date-picker>
              <button class="primaryBtn" @click="serachData1">搜索</button>
            </span>
          </div>
          <div class="title">
            <b>日巡检异常数</b>
          </div>
          <div class="echartsBox" :style="chartObject">
            <echarts ref="dayChart" chart-id="dayChart" :chartOption="options"></echarts>
          </div>
          <div class="noneData" v-if="noneData1">
            <span>暂无数据</span>
          </div>
        </div>
        <div class="rightAsides common">
          <div class="query">
            <span>
              <el-date-picker v-model="creatTime" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
              </el-date-picker>
              <button class="primaryBtn" @click="serachData2">搜索</button>
            </span>
          </div>
          <div class="title">
            <b>月巡检异常数</b>
          </div>
          <div class="echartsBox" :style="chartObject">
            <echarts ref="monthChart" chart-id="monthChart" :chartOption="options1"></echarts>
          </div>
          <div class="noneData" v-if="noneData2">
            <span>暂无数据</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '6%',
          top: '8%',
          containLabel: true
        },
        legend: {
          data: [],
          right: 10,
          top: 12,
          textStyle: {
            color: "#333"
          },
          itemWidth: 12,
          itemHeight: 10,
          // itemGap: 35
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: '#333'

            }
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              // fontFamily: 'Microsoft YaHei'
            }
          },
        },

        yAxis: {
          type: 'value',
          // max: '1200',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#333'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        "dataZoom": [{
          "show": true,
          "height": 12,
          "xAxisIndex": [
            0
          ],
          bottom: '2%',
          "start": 10,
          "end": 90,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '110%',
          handleStyle: {
            color: "#d3dee5",

          },
          textStyle: {
            color: "#fff"
          },
          borderColor: "#90979c"
        }, {
          "type": "inside",
          "show": true,
          "height": 15,
          "start": 1,
          "end": 35
        }],
        series: []
      },
      options1: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '6%',
          top: '8%',
          containLabel: true
        },
        legend: {
          data: [],
          right: 10,
          top: 12,
          textStyle: {
            color: "#333"
          },
          itemWidth: 12,
          itemHeight: 10,
          // itemGap: 35
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: '#333'

            }
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              // fontFamily: 'Microsoft YaHei'
            }
          },
        },

        yAxis: {
          type: 'value',
          // max: '1200',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#333'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        "dataZoom": [{
          "show": true,
          "height": 12,
          "xAxisIndex": [
            0
          ],
          bottom: '2%',
          "start": 10,
          "end": 90,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '110%',
          handleStyle: {
            color: "#d3dee5",

          },
          textStyle: {
            color: "#fff"
          },
          borderColor: "#90979c"
        }, {
          "type": "inside",
          "show": true,
          "height": 15,
          "start": 1,
          "end": 35
        }],
        series: []
      },
      dayTime: '',
      fbdate: null,
      fedate: null,
      creatTime: [],
      pickerOptions: {
        shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      styleObject: {
        height: ""
      },
      chartObject: {
        height: ""
      },
      noneData1: false,
      noneData2: false,
      date: new Date()
    };
  },
  created() {
    // console.log(this.storage.getSession("sysStartTime"));
    // this.creatTime[0] = this.formatterDate(this.storage.getSession("sysStartTime"));
    // this.creatTime[1] = new Date();
    this.creatTime = [new Date(new Date() - 3600 * 1000 * 24 * 30), new Date()]
    this.makeheight();
    this.chartheight()
    this.reloaTable();
    this.getDayData(this.timeInit.getYMD(this.date))
  },
  methods: {
    handleData(data) {
      // console.log(data);
      let xarry = []
      data.forEach((item, j) => {
        xarry.push(item.date)
      })
      let dataArr = []
      let datas = []
      data[0].typeInfo.forEach((val, index) => {
        datas.push(val.typeName)
        if (!dataArr[index]) {
          dataArr[index] = []
        }
        data.forEach((val2, j) => {
          dataArr[index].push(val2.typeInfo[index].count)
        })
      })

      // console.log(dataArr);
      let series = []
      data[0].typeInfo.forEach((type, i) => {
        series.push({
          name: type.typeName,
          type: 'bar',
          barWidth: '15%',
          // itemStyle: {
          //   normal: {
          //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //           offset: 0,
          //           color: '#8bd46e'
          //       }, {
          //           offset: 1,
          //           color: '#09bcb7'
          //       }]),
          //       barBorderRadius: 11,
          //   }

          // },
          data: dataArr[i]
        })
      })
      // console.log(series);
      this.options1.legend.data = datas
      this.options1.series = series
      this.options1.xAxis.data = xarry
    },
    handleData1(data) {
      // console.log(data);
      let xarry = []
      data.forEach((item, j) => {
        xarry.push(item.date+'点')
      })
      let dataArr = []
      let datas = []
      data[0].typeInfo.forEach((val, index) => {
        datas.push(val.typeName)
        if (!dataArr[index]) {
          dataArr[index] = []
        }
        data.forEach((val2, j) => {
          dataArr[index].push(val2.typeInfo[index].count)
        })
      })

      // console.log(dataArr);
      let series = []
      data[0].typeInfo.forEach((type, i) => {
        series.push({
          name: type.typeName,
          type: 'bar',
          barWidth: '15%',
          data: dataArr[i]
        })
      })
      // console.log(series);
      this.options.legend.data = datas
      this.options.series = series
      this.options.xAxis.data = xarry
    },
    serachData1() {
      //查询//搜索
      this.getDayData(this.timeInit.getYMD(this.date))
    },
    serachData2() {
      //查询//搜索
      this.reloaTable();
    },
    // 根据日期统计异常数/front/polling/day/statistics/getAbnormalCount
    getDayData(data) {
      let params = {
        date: data
      }
      this.request.get("/front/polling/day/statistics/getAbnormalCount", params).then(res => {
        console.log(res)
        if (res.code == 200) {
          if (res.data.length) {
           this.handleData1(res.data)
           this.noneData1 = false
          } else {
            this.noneData1 = true
            // this.options.xAxis.data=[]
            // this.options.series[0].data=[]
          }
        } else if (res.code == 500) {
          this.msg.warn("查询当天的异常数不存在")
          this.noneData1 = true
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getCurrentYear() { //根据月份统计异常数
      // console.log(this.creatTime);
      if (this.creatTime != null && this.creatTime.length) {
        let date = new Date();
        let y = date.getFullYear();

        let date0 = this.creatTime[0];
        let y0 = date0.getFullYear();

        let date1 = this.creatTime[1];
        let y1 = date1.getFullYear();

        let date2 = this.creatTime[0];
        let y2 = this.formatDate(date2)
        let data3 = this.formatterDate(this.storage.getSession("sysStartTime"));
        let y3 = this.formatDate(data3)

        if (y0 > y) {
          this.msg.error('输入开始日期年份大于当前年份，请重新输入！')
        } else if (y1 > y) {
          this.msg.error('输入结束日期年份大于当前年份，请重新输入！')
        } else if (y3 > y2) {
          this.msg.error('选择时间小于系统开始时间，请重新输入！')
        } else {
          this.tableLoading = true
          this.fbdate = this.formatDate(this.creatTime[0]);
          this.fedate = this.formatDate(this.creatTime[1]);
          this.params = {
            "endDate": this.fedate,
            "startDate": this.fbdate
          }
          this.request.get("/front/polling/month/statistics/getAbnormalCount", this.params).then(res => {
            console.log(res)
            if (res.code == 200) {
              if (res.data.length) {
                this.handleData(res.data)
              } else {
                this.noneData2 = true
              }
            } else if (res.code == 500) {
              this.msg.warn("查询月份的异常数不存在")
              this.noneData2 = true
            }
          }).catch(error => {
            console.log(error)
          })
        }
      } else {
        this.msg.warn("请选择开始日期和结束日期！")
      }
    },
    reloaTable() {
      this.getCurrentYear()
    },
    formatDate(d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day;
      return times;
    },
    formatterDate(date) {
      let result = new Date(date);
      return result;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    chartheight(height = 236) {
      let _this = this;
      _this.chartObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.chartObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.PatrolStatistics {
  position: relative;

  .mainContent {
    .query {
      margin-bottom: 0 !important;
    }

    margin: 12px;
    // background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .container {
      height: 100%;

      .query {
        padding: 20px;
        background: #fff;
        margin-bottom: 20px;
      }

      .chartContainer {
        overflow: hidden;

        .leftAsides {
          position: relative;
          width: 49.5%;
          float: left;
          height: 100%;
          background: #fff;
        }

        .rightAsides {
          position: relative;
          margin-left: 1%;
          background: #fff;
          float: left;
          width: 49.5%;
          height: 100%;
        }

        .common {
          .echartsBox {}

          .noneData {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -50px;

            span {
              font-size: 24px;
              color: #333;
              font-weight: 400;
            }
          }

          .title {
            overflow: hidden;
            height: 42px;
            line-height: 42px;
            padding: 0 15px;
            border-bottom: 1px solid #f6f6f6;
            color: #333;
            border-radius: 2px 2px 0 0;
            font-size: 0;
            box-sizing: border-box;

            b {
              float: left;
              font-weight: 400;
              font-size: 14px;
              color: #333;
            }

            span {
              float: right;
              font-weight: 400;
              font-size: 14px;
              color: #333;

              i {
                font-weight: normal;
                color: #378fe8;
                font-size: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style><style lang="scss">
.PatrolStatistics {
  .query {
    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }

    .el-date-editor {
      margin-right: 10px;

      .el-input__inner {
        height: 36px;
        line-height: 36px;
      }

      .el-input__icon {
        line-height: 36px;
      }
    }
  }
}
</style>
